module.exports = __webpack_public_path__ + "static/media/liquido.4833cc87.png";